// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Image-space1-ekzR0 {
	margin-bottom: 6px !important;
}

.Image-space2-DcDYN {
	margin-bottom: 12px !important;
}

.Image-space3-qgoZr {
	margin-bottom: 18px !important;
}

.Image-space4-AO2a7 {
	margin-bottom: 24px !important;
}

.Image-space5-WArLj {
	margin-bottom: 30px !important;
}

.Image-space6-yxYe5 {
	margin-bottom: 36px !important;
}

.Image-space7-XnNc_ {
	margin-bottom: 42px !important;
}

.Image-space8-qkhNs {
	margin-bottom: 48px !important;
}

.Image-spaceTop1-N2_Ip {
	margin-top: 6px !important;
}

.Image-spaceTop2-ChvwJ {
	margin-top: 12px !important;
}

.Image-spaceTop3-OyPiK {
	margin-top: 18px !important;
}

.Image-spaceTop4-m3kvZ {
	margin-top: 24px !important;
}

.Image-spaceTop5-R2Ppq {
	margin-top: 30px !important;
}

.Image-spaceTop6-XoLB0 {
	margin-top: 36px !important;
}

.Image-spaceTop7-zcwlG {
	margin-top: 42px !important;
}

.Image-spaceTop8-rVMMl {
	margin-top: 48px !important;
}

.Image-noMargin-tyhCL {
	margin: 0px !important;
}

.Image-padding1-COCNq {
	padding-bottom: 6px !important;
}

.Image-padding2-gQoGY {
	padding-bottom: 12px !important;
}

.Image-padding3-ryjNo {
	padding-bottom: 18px !important;
}

.Image-padding4-qOcJN {
	padding-bottom: 24px !important;
}

.Image-padding5-jRv81 {
	padding-bottom: 30px !important;
}

.Image-padding6-NmF6V {
	padding-bottom: 36px !important;
}

.Image-padding7-estPy {
	padding-bottom: 42px !important;
}

.Image-paddingTop1-QDxvU {
	padding-top: 6px !important;
}

.Image-paddingTop2-yqCxA {
	padding-top: 12px !important;
}

.Image-paddingTop3-jgxQD {
	padding-top: 18px !important;
}

.Image-paddingTop4-N0esx {
	padding-top: 24px !important;
}

.Image-paddingTop5-HPfX7 {
	padding-top: 30px !important;
}

.Image-paddingTop6-IVVgg {
	padding-top: 36px !important;
}

.Image-paddingTop7-fP89j {
	padding-top: 42px !important;
}

.Image-noPadding-cb271 {
	padding: 0px !important;
}

.Image-spaceMarginBottom0-xlkGM {
	margin-bottom: 0;
}

.Image-textBold-tMAzX {
	font-weight: 500 !important;
}

.Image-textBolder-Hpm_I {
	font-weight: 700 !important;
}

.Image-textNormal-hAhbv {
	font-weight: normal !important;
}

/*New Design Text Colors */

.Image-textDarkBlue-ez9KC {
	color: rgb(20, 39, 94) !important;
}

.Image-textLightBlue-gRWJh {
	color: rgb(57, 87, 106) !important;
}

.Image-textLightSandleGreen-uu9b1 {
	color: rgb(76, 86, 41) !important;
}

.Image-textLightBrown-NK3CT {
	color: rgb(115, 79, 33) !important;
}

.Image-textMediumMaroon-pLXsH {
	color: rgb(87, 37, 51) !important;
}

.Image-textBrown-iZir9 {
	color: rgb(160, 47, 24) !important;
}

.Image-textMaroon-AsLIa {
	color: rgb(155, 49, 67) !important;
}

.Image-textDarkBrown-WkjMa {
	color: rgb(83, 18, 16) !important;
}

.Image-textMediumBrown-h5eFP {
	color: rgb(142, 28, 10) !important;
}

.Image-textSkyBlue-JxNj0 {
	color: rgb(37, 117, 141) !important;
}

.Image-textGray-p6YRT {
	color: rgb(77, 65, 51) !important;
}

.Image-errorMessage-oZMJ4 {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.Image-userText-hPUhZ {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.Image-panelHeader-HMQGb {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.Image-exportSection-JGXza {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.Image-exportSectionGridSub-sp1gQ {
	grid-template-columns: 50% 49% !important;
}

.Image-exportText-iVvBM {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.Image-exportLinkImg-dC4Vm {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.Image-exportImg-ulp0N {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.Image-linkBtn-t9vOj {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.Image-table-sWZ6H {
	display: table;
}

.Image-tableRow-yGDEi {
	display: table-row;
}

.Image-tableCell-ulQbb {
	display: table-cell;
	float: none;
}

.Image-formGroup-snwCV {
	margin-bottom: 6px;
}

.Image-marginTop0-pOaEk {
	margin-top: 0;
}

.Image-marginBottom20-zpOOH {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.Image-bannerImageBg-oX3Gk {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.Image-bannerDelete-DsAvC {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.Image-exportLink-wLELs {
	padding-top: 10px;
	padding-right: 10px;
}

.Image-seachContent-nPaTA {
	padding-left: 0px;
	margin-bottom: 5px;
}

.Image-marginBottom9-xPJZj {
	margin-bottom: 9px;
}

.Image-spaceTop52-b7c3w {
	margin-top: 52px;
}

.Image-profileViewInner-sgum3 {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.Image-profileViewMain-bQ8nM {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.Image-profileViewlabel-Q20Oa {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.Image-profileViewMainContent-cgGDU {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.Image-reviewsFormStar-F6HHo {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.Image-reviewsFormStar-F6HHo svg {
	cursor: pointer;
}

.Image-addLanguageText-Q4WxN {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.Image-exportSection-JGXza {
		grid-template-columns: 100%;
	}

	.Image-spaceTop52-b7c3w {
		margin-top: 18px;
	}

	.Image-exportText-iVvBM {
		float: none;
		margin-top: 12px;
	}

	.Image-exportSectionGridSub-sp1gQ {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.Image-profileViewlabel-Q20Oa {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.Image-profileViewMainContent-cgGDU {
		width: 100%;
		text-align: center;
	}

	.Image-panelHeader-HMQGb {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Image-space1-ekzR0`,
	"space2": `Image-space2-DcDYN`,
	"space3": `Image-space3-qgoZr`,
	"space4": `Image-space4-AO2a7`,
	"space5": `Image-space5-WArLj`,
	"space6": `Image-space6-yxYe5`,
	"space7": `Image-space7-XnNc_`,
	"space8": `Image-space8-qkhNs`,
	"spaceTop1": `Image-spaceTop1-N2_Ip`,
	"spaceTop2": `Image-spaceTop2-ChvwJ`,
	"spaceTop3": `Image-spaceTop3-OyPiK`,
	"spaceTop4": `Image-spaceTop4-m3kvZ`,
	"spaceTop5": `Image-spaceTop5-R2Ppq`,
	"spaceTop6": `Image-spaceTop6-XoLB0`,
	"spaceTop7": `Image-spaceTop7-zcwlG`,
	"spaceTop8": `Image-spaceTop8-rVMMl`,
	"noMargin": `Image-noMargin-tyhCL`,
	"padding1": `Image-padding1-COCNq`,
	"padding2": `Image-padding2-gQoGY`,
	"padding3": `Image-padding3-ryjNo`,
	"padding4": `Image-padding4-qOcJN`,
	"padding5": `Image-padding5-jRv81`,
	"padding6": `Image-padding6-NmF6V`,
	"padding7": `Image-padding7-estPy`,
	"paddingTop1": `Image-paddingTop1-QDxvU`,
	"paddingTop2": `Image-paddingTop2-yqCxA`,
	"paddingTop3": `Image-paddingTop3-jgxQD`,
	"paddingTop4": `Image-paddingTop4-N0esx`,
	"paddingTop5": `Image-paddingTop5-HPfX7`,
	"paddingTop6": `Image-paddingTop6-IVVgg`,
	"paddingTop7": `Image-paddingTop7-fP89j`,
	"noPadding": `Image-noPadding-cb271`,
	"spaceMarginBottom0": `Image-spaceMarginBottom0-xlkGM`,
	"textBold": `Image-textBold-tMAzX`,
	"textBolder": `Image-textBolder-Hpm_I`,
	"textNormal": `Image-textNormal-hAhbv`,
	"textDarkBlue": `Image-textDarkBlue-ez9KC`,
	"textLightBlue": `Image-textLightBlue-gRWJh`,
	"textLightSandleGreen": `Image-textLightSandleGreen-uu9b1`,
	"textLightBrown": `Image-textLightBrown-NK3CT`,
	"textMediumMaroon": `Image-textMediumMaroon-pLXsH`,
	"textBrown": `Image-textBrown-iZir9`,
	"textMaroon": `Image-textMaroon-AsLIa`,
	"textDarkBrown": `Image-textDarkBrown-WkjMa`,
	"textMediumBrown": `Image-textMediumBrown-h5eFP`,
	"textSkyBlue": `Image-textSkyBlue-JxNj0`,
	"textGray": `Image-textGray-p6YRT`,
	"errorMessage": `Image-errorMessage-oZMJ4`,
	"userText": `Image-userText-hPUhZ`,
	"panelHeader": `Image-panelHeader-HMQGb`,
	"exportSection": `Image-exportSection-JGXza`,
	"exportSectionGridSub": `Image-exportSectionGridSub-sp1gQ`,
	"exportText": `Image-exportText-iVvBM`,
	"exportLinkImg": `Image-exportLinkImg-dC4Vm`,
	"exportImg": `Image-exportImg-ulp0N`,
	"linkBtn": `Image-linkBtn-t9vOj`,
	"table": `Image-table-sWZ6H`,
	"tableRow": `Image-tableRow-yGDEi`,
	"tableCell": `Image-tableCell-ulQbb`,
	"formGroup": `Image-formGroup-snwCV`,
	"marginTop0": `Image-marginTop0-pOaEk`,
	"marginBottom20": `Image-marginBottom20-zpOOH`,
	"bannerImageBg": `Image-bannerImageBg-oX3Gk`,
	"bannerDelete": `Image-bannerDelete-DsAvC`,
	"exportLink": `Image-exportLink-wLELs`,
	"seachContent": `Image-seachContent-nPaTA`,
	"marginBottom9": `Image-marginBottom9-xPJZj`,
	"spaceTop52": `Image-spaceTop52-b7c3w`,
	"profileViewInner": `Image-profileViewInner-sgum3`,
	"profileViewMain": `Image-profileViewMain-bQ8nM`,
	"profileViewlabel": `Image-profileViewlabel-Q20Oa`,
	"profileViewMainContent": `Image-profileViewMainContent-cgGDU`,
	"reviewsFormStar": `Image-reviewsFormStar-F6HHo`,
	"addLanguageText": `Image-addLanguageText-Q4WxN`
};
module.exports = ___CSS_LOADER_EXPORT___;
